var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8RfidSignal50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03A9F4",
    d: "M24 21A3 3 0 1 0 24 27A3 3 0 1 0 24 21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03A9F4",
    d: "M30.8 24c0 3.2-2.3 6-5.3 6.6l1.3 2C30.4 31.4 33 28 33 24s-2.6-7.4-6.3-8.6l-1.3 2C28.5 18 30.8 20.8 30.8 24zM17.2 24c0-3.2 2.3-6 5.3-6.6l-1.3-2C17.6 16.6 15 20 15 24s2.6 7.4 6.3 8.6l1.3-2C19.5 30 17.2 27.2 17.2 24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4FC3F7",
    d: "M29.7 11.2L28.4 13c4.3 1.8 7.4 6 7.4 11s-3.1 9.2-7.4 11l1.2 1.8c5-2.2 8.4-7.1 8.4-12.8S34.6 13.4 29.7 11.2zM18.3 36.8l1.2-1.8c-4.3-1.8-7.4-6-7.4-11s3.1-9.2 7.4-11l-1.2-1.8C13.4 13.4 10 18.3 10 24S13.4 34.6 18.3 36.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B3E5FC",
    d: "M16.7 39.2C11 36.5 7.1 30.7 7.1 24S11 11.5 16.7 8.8L15.5 7C9.3 10.2 5 16.6 5 24s4.3 13.8 10.5 17L16.7 39.2zM32.5 7l-1.2 1.8c5.7 2.7 9.6 8.5 9.6 15.2S37 36.5 31.3 39.2l1.2 1.8C38.7 37.8 43 31.4 43 24S38.7 10.2 32.5 7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8RfidSignal50);
export default __webpack_public_path__ + "static/media/icons8-rfid-signal-50.2aa7e494cfa53375b0c3fdefd5f5f076.svg";
export { ForwardRef as ReactComponent };